<template>
  <div class="container-fluid bmo-form">
    <div class="card-header py-3">
      <h6 class="m-0 font-weight-bold text-primary">Create Internal Product</h6>
    </div>
    <div class="card-body text-align-left">
      <Form type="Create" @submit="handleFormSubmit" />
    </div>
    <!-- close card body -->
  </div>
  <!-- close container-fluid -->
</template>

<script>
import Form from '@/components/Forms/InternalProductForm.vue';
import router from '@/router';

export default {
  name: 'CreateInternalProduct',
  components: {
    Form,
  },
  methods: {
    handleFormSubmit() {
      router.push('/internal-products');
    }
  }
};
</script>